import Cookies from "js-cookie";

export const setJWT = (token) => {
  Cookies.set("token", token, { expires: 7 });
};

export const getJWT = () => {
  return Cookies.get("token");
};
